import React, { useLayoutEffect } from 'react'
import useJquery from 'react-use-jquery';
import { Link } from 'react-router-dom'


export default function BusinessConsulting() {

    const $ = useJquery();

    //useEffects
    useLayoutEffect(() => {

        window.scrollTo(0, 0);
        $('.scroll-to').on("click", function () {
            var $element = $($(this).attr('href'))
            if ($(this).hasClass("make-it-active")) {
                if ($(this).parent().prop("tagName") === "LI") {
                    $(this).parent().parent().find(".active").removeClass("active")
                    $(this).parent().addClass("active")
                }
            }
            $('html, body').animate({ scrollTop: $element.offset().top - $('#masthead').height() - 40 }, { duration: 500 })
            return false;
        });

    });


    return (
        <>
            {/* page-title */}
            <div className="ttm-page-title-row">
                <div className="ttm-page-title-row-inner ttm-bgcolor-darkgrey">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <div className="page-title-heading">
                                    <h2 className="title">مشاور کسب و کار</h2>
                                </div>
                                <div className="breadcrumb-wrapper">
                                    <span>
                                        <i className="ti ti-home margin_right1" />
                                        <Link title="Homepage" to="/services">خدمات ما</Link>
                                    </span>
                                    <span>خدمات ما</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*site-main start*/}
            <div className="site-main">
                <div className="ttm-row sidebar ttm-sidebar-left ttm-bgcolor-white overflow-hidden clearfix">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 widget-area sidebar-left ttm-col-bgcolor-yes ttm-bg ttm-left-span ttm-bgcolor-grey mt_80 padding_top80 mb_80 padding_bottom80 res-991-margin_top0 res-991-padding_top0">
                                <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
                                <aside className="widget widget-nav-menu with-title">
                                    <h3 className="widget-title">خدمات</h3>
                                    <ul>
                                        <li className="active"><a className="scroll-to" href="#description"> مشاوره به کسب و کارها
                                        </a>
                                        </li>
                                        <li><a className="scroll-to" href="#startup"> مشاوره به استارتاپ ها </a></li>
                                        <li><a className="scroll-to" href="#improve-online-marcketing"> ارتقا فروش آنلاین </a>
                                        </li>
                                    </ul></aside>
                                <aside className="widget contact-widget with-title">
                                    <h3 className="widget-title">در تماس باشید</h3>
                                    <ul className="contact-widget-wrapper">
                                        <li><i className="ttm-textcolor-skincolor ti ti-location-pin" /> مشهد،
                                            جنب میدان
                                            معلم، پلاک ۶۲</li>
                                        <li><i className="ttm-textcolor-skincolor ti ti-email" /><a href="mailto:info@asraweb.com" target="_blank">info@asraweb.com</a></li>
                                        <li><i className="ttm-textcolor-skincolor ti ti-mobile" /><a href="tel:+00-123-456-789">0516076022</a></li>
                                        <li><i className="ttm-textcolor-skincolor ti ti-alarm-clock" />شنبه تا پنجشنبه - 9:00
                                            صبح تا 5:00 بعد از ظهر</li>
                                    </ul>
                                </aside>
                            </div>
                            <div className="col-lg-8 content-area">
                                <div className="ttm-service-single-content-area" id="description">
                                    <div className="ttm-service-description">
                                    <h3>ما با چالش های بازار آنلاین بخوبی آشنایی داریم</h3>
                                    <p>هر کسب و کاری برای دستیابی به به اهداف تجاری لازم است به جای آزمون و خطا، از مشاورین حوزه کسب و کار کمک بگیرد. گروه اسراوب در کنار نقش اجرایی، می تواند به عنوان مشاور حوزه وب مارکتینگ و بازار آنلاین نیز در خدمت مدیران محترم کسب و کارها باشد.</p>
                                    <p>اعضای تیم مدیریتی اسراوب سابقه همکاری با تیم های متعدد در پروژه های متنوعی را داشته و همچنین تجربه حضور در چندین استارتاپ و رویداد استارتاپی را دارند.</p>

                                        <div className="padding_top20">
                                            <div className="row">
                                                {/* align-items-center*/}
                                                <div className="col-sm-6 col-md-6">
                                                    <div className="ttm_single_image-wrapper res-991-padding_bottom30">
                                                        <img className="img-fluid" src="/assets/images/bussiness_consulting.jpg" alt="single-11" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-md-6">
                                                    {/* featured-icon-box */}
                                                    <div className="featured-icon-box icon-align-before-title">
                                                        <div className="featured-icon">
                                                            <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                                                                <i className="flaticon-outsorcing" />
                                                            </div>
                                                        </div>
                                                        <div className="featured-title">
                                                            <h3>ارائه مشاوره اولیه رایگان</h3>
                                                        </div>
                                                        <div className="featured-content">
                                                            <div className="featured-desc">
                                                                <p>
                                                                اگر می خواهید با خدمات مشاوره ای ما آشنایی پیدا کرده و توان ما را محک بزنید می توانید با ما یک جلسه مشاوره رایگان داشته باشید. اسراوب همواره آماده ارزیابی کسب و کار شما و ارائه پیشنهادات تجاری است.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>{/* featured-icon-box end */}
                                                    <div className="ttm-horizontal_sep width-100 margin_top25 margin_bottom25">
                                                    </div>
                                                    {/* featured-icon-box */}
                                                    <div className="featured-icon-box icon-align-before-title">
                                                        <div className="featured-icon">
                                                            <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                                                                <i className="flaticon-meeting" />
                                                            </div>
                                                        </div>
                                                        <div className="featured-title">
                                                            <h3>حذف دردسر همگام سازی تیم ها</h3>
                                                        </div>
                                                        <div className="featured-content">
                                                            <div className="featured-desc">
                                                            <p>ما بخوبی آگاهیم که همگام سازی تیم های مختلف تا چه اندازه می تواند دشوار باشد، وقتی مشاور شما نقش اجرایی هم داشته باشد شما از دردسرهای مرتبط با همگام سازی تیم ها راحت می شوید و تنها با یک گروه سر و کار دارید.</p>
                                                            </div>
                                                        </div>
                                                    </div>{/* featured-icon-box end */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ttm-horizontal_sep width-100 margin_top35 margin_bottom25" />
                                        <div className="row" id="startup">
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-7">
                                                <div className="res-991-padding_top30 padding_left10 res-991-padding_left0">
                                                    <h3>مشاوره به تیم های استارتاپی</h3>
                                                    <p>استارتاپ ها معمولا بر اساس ایده شکل می گیرند و اکثر اوقات به دلیل تعصب روی ایده، عدم شناخت مسیر اصولی، اعتبارسنجی نادرست ایده و ده ها عامل دیگر، شکست می خورند. تیم اسراوب با فرآیند اصولی راه اندازی استارتاپ بخوبی آشنا بوده و به لطف حضور در کارگاه های متعدد و ارتباط با اساتید بنام حوزه کارآفرینی می تواند در مسیر پر چالش راه اندازی استارتاپ در کنار شما باشد.</p>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-5">
                                                <div className="d-inline-block single-img-wraper p-15 ttm-bgcolor-grey border-rad_6">
                                                    <img className="img-fluid auto_size" src="/assets/images/startup_mentoring.jpg" alt="image" width={500} height={375} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ttm-horizontal_sep width-100 margin_top35 margin_bottom25" />
                                        <div className="row" id="improve-online-marcketing">
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-5">
                                                <div className="d-inline-block single-img-wraper p-15 ttm-bgcolor-grey border-rad_6">
                                                    <img className="img-fluid auto_size" src="/assets/images/improve_selling.jpg" alt="image" width={500} height={375} />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-7">
                                                <div className="res-991-padding_top30 padding_left10 res-991-padding_left0">
                                                    <h3>مشاوره  در جهت راه اندازی و ارتقا فروش آنلاین</h3>
                                                    <p>فروش آنلاین یه فرآیند چند وجهی است و میزان موفقیت در آن به عوامل زیادی وابسته است. اگر شما بخوبی با همه فاکتورها و سیاست های مارکتینگ آنلاین آشنا نباشید ممکن است در صورت اقدام با نتایجی بسیار پایین تر از حد انتظار خود رو به رو شوید. اسراوب می تواند شما از سیاست های اصولی این مبحث آگاه کند و در مسیر اجرای این سیاست ها در کنار شما باشد.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}